import RawOrder from "ts/api/order";
import { ProductConfigsBySupplier } from "store/custom-product-option/custom-product-option-shop.store";
import { CpoConfigById } from "store/custom-product-option/custom-product-option-configs.store";
import { CustomProductOptionConfigType } from "@evennt-tech/api-v2-core";

export const getOrderCpoConfigIds = <T extends RawOrder>(
  orders: T[]
): string[] => {
  const idsSet = orders.reduce<Set<string>>((acc, order) => {
    order.products.forEach((p) => {
      if (p.cpoConfig) {
        acc.add(p.cpoConfig.id);
      }
    });
    return acc;
  }, new Set());

  return Array.from(idsSet);
};

export const getOrderCpoConfigs = <T extends RawOrder>(
  configsBySupplier: ProductConfigsBySupplier,
  order: T
) => {
  return order.products.reduce<CpoConfigById>((acc, product) => {
    const isValidCustomConfig = product?.cpoConfig?.isCustom;
    if (!isValidCustomConfig) {
      return acc;
    }
    const productConfigs = configsBySupplier
      .get(product.owner.id)
      ?.get(product.id)?.configs;
    if (!productConfigs?.length) {
      return acc;
    }
    const config = productConfigs.find(
      (c) =>
        c.id === product.cpoConfig?.id &&
        c.type === CustomProductOptionConfigType.CUSTOM
    );
    if (config) {
      acc.set(config.id, config);
    }

    return acc;
  }, new Map());
};
